<!-- @format -->

<template>
	<el-row :gutter="6">
		<el-col :span="24">
			<el-radio-group v-model="paramsType" size="small" @change="onTypeChange">
				<el-radio-button :label="paramsTypeEnum.人工">人工</el-radio-button>
				<el-radio-button :label="paramsTypeEnum.引用">引用</el-radio-button>
				<el-radio-button :label="paramsTypeEnum.业务对象">业务对象</el-radio-button>
			</el-radio-group>
		</el-col>
		<el-col :span="24">
			<!-- <el-select
				v-if="paramsType === paramsTypeEnum.引用"
				v-model="citeType"
				size="small"
				clearable
				filterable
				placeholder="请选择数据源"
				class="select"
				@change="onSelect"
			>
				<el-option v-for="item in citeState.citeTypeList" :key="item.value" :label="item.label" :value="item.value" />
			</el-select> -->
			<template v-if="paramsType !== paramsTypeEnum.业务对象">
				<el-tree-select
					v-if="paramsType === paramsTypeEnum.引用"
					v-model="citeType"
					:data="citeState.citeTypeList"
					:render-after-expand="false"
					size="small"
					clearable
					filterable
					placeholder="请选择数据源"
					class="select"
					check-strictly
					@change="onSelect"
				/>
				<el-button v-else size="small" @click="onAdd">新增</el-button>
			</template>
			<template v-else>
				业务对象
				<el-select
					v-model="objectType"
					size="small"
					clearable
					filterable
					placeholder="请选业务对象"
					class="select"
					@change="changeObjectType"
				>
					<el-option v-for="item in objectParams1" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
				对象服务
				<el-select
					v-model="objectServer"
					size="small"
					clearable
					filterable
					placeholder="请选对象服务"
					class="select"
					@change="changeObjectServer"
				>
					<el-option v-for="item in objectParams2" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
				指定value
				<el-select v-model="objectValue" size="small" clearable filterable placeholder="请选指定value" class="select">
					<el-option v-for="item in objectParams3" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
				指定label
				<el-select v-model="objectLabel" size="small" clearable filterable placeholder="请选指定label" class="select">
					<el-option v-for="item in objectParams3" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
			</template>
		</el-col>
		<el-col :span="4" />
		<el-col :span="9">
			<label class="label">名称</label>
		</el-col>
		<el-col :span="10">
			<label class="label">编码</label>
		</el-col>

		<draggable
			v-if="paramsType === paramsTypeEnum.人工"
			:list="value"
			item-key="id"
			class="params-drag"
			v-bind="{
				group: { name: 'setting-params', pull: false, put: false },
				sort: true,
				handle: '.params-drag-icon',
				ghostClass: 'params-drag-ghost',
				animation: 300,
			}"
		>
			<template #item="{ element: item }: { element: WidgetConfigOption }">
				<el-row :gutter="6">
					<el-col :span="4" style="display: flex; justify-content: space-between">
						<span class="params-drag-icon">
							<el-icon size="18" style="display: inline"><Rank /></el-icon>
						</span>
						<el-checkbox
							:model-value="defaultValue.includes(item.value)"
							class="params-checkbox"
							size="large"
							@change="(e:boolean) => onChecked(e, item.value)"
						/>
					</el-col>
					<el-col :span="9">
						<el-input v-model="item.label" size="small" placeholder="请输入名称"></el-input>
					</el-col>
					<el-col :span="9">
						<el-input v-model="item.value" size="small" placeholder="请输入编码"></el-input>
					</el-col>
					<el-col :span="2">
						<el-icon class="form-item-content-icon" @click.stop.prevent="onDel(item)">
							<Delete />
						</el-icon>
					</el-col>
				</el-row>
			</template>
		</draggable>
		<template v-if="paramsType === paramsTypeEnum.引用 || paramsType === paramsTypeEnum.业务对象">
			<el-scrollbar max-height="200px">
				<el-row v-for="item in citeState.citeList" :key="item.value" :gutter="6">
					<el-col :span="2" :offset="2" style="display: flex; justify-content: space-between">
						<el-checkbox
							:model-value="defaultValue.includes(item.value)"
							class="params-checkbox"
							size="large"
							@change="(e:boolean) => onChecked(e, item.value)"
						/>
					</el-col>
					<el-col :span="9">
						<el-input v-model="item.label" size="small" placeholder="请输入名称" readonly></el-input>
					</el-col>
					<el-col :span="9">
						<el-input v-model="item.value" size="small" placeholder="请输入编码" readonly></el-input>
					</el-col>
				</el-row>
			</el-scrollbar>
		</template>
		<template v-if="paramsType === paramsTypeEnum.业务对象">
			<el-row :gutter="6">
				<el-col :span="24">
					<el-button size="small" class="add-btn" @click="linkConfigAdd">新增</el-button>
				</el-col>
				<el-col :span="1" />
				<el-col :span="10">
					<label class="label">关联对象</label>
				</el-col>
				<el-col :span="10">
					<label class="label">关联数据</label>
				</el-col>

				<el-row v-for="(item, idx) in linkConfig" :key="idx" :gutter="6">
					<el-col :span="1" />
					<el-col :span="10">
						<el-select v-model="item.code" size="small" placeholder="请选择关联对象">
							<el-option v-for="itm in fieldList" :key="itm.value" :label="itm.label" :value="itm.value" />
						</el-select>
					</el-col>
					<el-col :span="10">
						<el-select v-model="item.link" size="small" placeholder="请选择关联数据">
							<el-option v-for="itm in objectParams3" :key="itm.value" :label="itm.label" :value="itm.value" />
						</el-select>
					</el-col>
					<el-col :span="3">
						<el-icon class="form-item-content-icon" @click.stop.prevent="linkConfigDel(idx)">
							<Delete />
						</el-icon>
					</el-col>
				</el-row>
			</el-row>
		</template>
	</el-row>
</template>

<script setup lang="ts">
	import { useDragStoreWithOut } from '../../store';
	import { type WidgetConfigOption } from '../../types';
	import { paramsTypeEnum } from '../../config';
	import { flat } from '../../utils/util';
	import type { FieldsType } from '../../types';
	import { draggable } from '@/components';
	import { useDictList, findTreeDataWithNoRoot } from '@/api';
	import { getCache, setCache } from '@/utils/util';
	import { getServeList, getBusinessManageList, getDataProcessList } from '@/api/factory';
	interface Props {
		modelValue: WidgetConfigOption[];
	}

	const props = withDefaults(defineProps<Props>(), {});

	const emit = defineEmits(['update:modelValue']);

	const name = inject<string>('name');

	const objectParams1: any = ref([]);
	const objectParams2: any = ref([]);
	const objectParams3: any = ref([]);

	const dragStore = useDragStoreWithOut(name);

	const fieldList = computed(() => {
		const flatWidgetDatas: FieldsType[] = flat(dragStore.widgetDatas);
		return flatWidgetDatas
			.filter((itm) => itm.category === 'field')
			.map((it) => ({ label: it.pcProps.label, value: it.code || '' }));
	});

	const DEFAULT_MULTIPLE_LIST = ['checkbox'];

	const value = computed({
		get() {
			return props.modelValue || [];
		},
		set(val) {
			emit('update:modelValue', val);
		},
	});

	// 字典列表
	const citeState = ref<{
		citeTypeList: { label: string; value: string }[];
		citeList: { label: string; value: string }[];
	}>({
		citeTypeList: [],
		citeList: [],
	});

	const defaultValue = computed({
		get() {
			return dragStore.selectField!.pcProps.defaultValue ? dragStore.selectField!.pcProps.defaultValue.split(',') : [];
		},
		set(val) {
			dragStore.selectField!.pcProps.defaultValue = val.toString();
		},
	});

	// 数据来源类型
	const paramsType = computed({
		get() {
			return dragStore.selectField!.pcProps.paramsType || paramsTypeEnum.人工;
		},
		set(val) {
			dragStore.selectField!.pcProps.paramsType = val;
		},
	});

	// 数据引用code
	const citeType = computed({
		get() {
			return dragStore.selectField!.pcProps.citeType || '';
		},
		set(val) {
			dragStore.selectField!.pcProps.citeType = val;
		},
	});

	const objectType = computed({
		get() {
			return dragStore.selectField!.pcProps.objectType || '';
		},
		set(val) {
			dragStore.selectField!.pcProps.objectType = val;
		},
	});

	const objectServer = computed({
		get() {
			return dragStore.selectField!.pcProps.objectServer || '';
		},
		set(val) {
			dragStore.selectField!.pcProps.objectServer = val;
		},
	});

	const objectValue = computed({
		get() {
			return dragStore.selectField!.pcProps.objectValue || '';
		},
		set(val) {
			dragStore.selectField!.pcProps.objectValue = val;
		},
	});

	const objectLabel = computed({
		get() {
			return dragStore.selectField!.pcProps.objectLabel || '';
		},
		set(val) {
			dragStore.selectField!.pcProps.objectLabel = val;
		},
	});

	const linkConfig = computed({
		get() {
			return dragStore.selectField!.pcProps.linkConfig;
		},
		set(val) {
			dragStore.selectField!.pcProps.linkConfig = val;
		},
	});

	const onAdd = () => {
		value.value.push({ value: '1', label: '1' });
	};

	const linkConfigAdd = () => {
		if (!linkConfig.value) {
			linkConfig.value = [];
		}
		linkConfig.value.push({ code: '', link: '' });
	};

	const onDel = (item: WidgetConfigOption) => {
		value.value = value.value.filter((itm) => itm.value !== item.value);
	};

	const linkConfigDel = (idx: number) => {
		linkConfig.value.splice(idx, 1);
	};

	const onChecked = (checked: boolean, code: string) => {
		if (checked) {
			if (dragStore.selectField?.pcProps.multiple || DEFAULT_MULTIPLE_LIST.includes(dragStore.selectField!.type)) {
				defaultValue.value = dragStore.selectField?.pcProps.multipleLimit
					? [...defaultValue.value, code].slice(0, dragStore.selectField?.pcProps.multipleLimit)
					: [...defaultValue.value, code];
			} else {
				defaultValue.value = [code];
			}
		} else {
			defaultValue.value = defaultValue.value.filter((itm) => itm !== code);
		}
	};

	const getCiteList = async (dictType: string) => {
		const cacheRes = getCache('dictCache', dictType);

		if (cacheRes) {
			citeState.value.citeList = cacheRes;
		} else {
			const res = await useDictList({ dictType });
			setCache('dictCache', dictType, res);
			citeState.value.citeList = res;
		}
	};

	const onSelect = async (dictType) => {
		defaultValue.value = [];
		await getCiteList(dictType);
	};

	const getCiteTypeList = async () => {
		const cacheAll = getCache('dictCache', 'dictCacheAll');
		if (cacheAll) {
			citeState.value.citeTypeList = arrayToTree(cacheAll || []);
		} else {
			const res = await findTreeDataWithNoRoot();
			setCache('dictCache', 'dictCacheAll', res);
			citeState.value.citeTypeList = arrayToTree(res || []);
		}
	};

	function arrayToTree(data, pIdKey = 'parentId', idKey = 'id', childrenKey = 'children') {
		const sNodes = JSON.parse(JSON.stringify(data));
		let i, j, l;
		if (!idKey || idKey === '' || !sNodes) {
			return [];
		}
		if (sNodes instanceof Array) {
			const r: any = [];
			const tmpMap: any = [];
			for (i = 0, l = sNodes.length; i < l; i++) {
				tmpMap[sNodes[i][idKey]] = sNodes[i];
			}

			for (j = 0, l = sNodes.length; j < l; j++) {
				// 判断是否是叶子节点
				if (tmpMap[sNodes[j][pIdKey]] && sNodes[j][idKey] !== sNodes[j][pIdKey]) {
					if (!tmpMap[sNodes[j][pIdKey]][childrenKey]) {
						tmpMap[sNodes[j][pIdKey]][childrenKey] = [];
					}
					tmpMap[sNodes[j][pIdKey]][childrenKey].push(sNodes[j]);
				} else {
					r.push(sNodes[j]);
				}
			}
			return r;
		} else {
			return [sNodes];
		}
	}

	const onTypeChange = async (e) => {
		citeState.value.citeList = [];
		defaultValue.value = [];
		objectType.value = '';
		objectServer.value = '';
		objectValue.value = '';
		objectLabel.value = '';
		if (e === paramsTypeEnum.引用 && !citeState.value.citeTypeList.length) {
			await getCiteTypeList();
		}
		if (e === paramsTypeEnum.业务对象 && !objectParams1.value.length) {
			getObjectParams1();
		}
	};

	const changeObjectType = (e) => {
		objectServer.value = '';
		objectValue.value = '';
		objectLabel.value = '';
		if (e) {
			getObjectParams2(e);
		}
	};

	const changeObjectServer = (e) => {
		objectValue.value = '';
		objectLabel.value = '';
		if (e) {
			getObjectParams3(e);
		}
	};

	const getObjectParams1 = async () => {
		const res: any = await getBusinessManageList({});
		objectParams1.value = res.data.map((it) => {
			return { value: it.code, label: it.objectName };
		});
	};

	const getObjectParams2 = async (e) => {
		const res: any = await getServeList({ businessCode: e });
		objectParams2.value = res.map((it) => {
			return { ...it, value: it.url, label: it.name };
		});
	};

	const getObjectParams3 = async (e) => {
		const data = objectParams2.value.find((it) => it.value === e);
		try {
			const dataArr = JSON.parse(data.outputParameter)[4]?.children || [];
			objectParams3.value = dataArr.map((it) => {
				return { value: it.name, label: it.remark };
			});
		} catch (error) {
			objectParams3.value = [];
		}
	};

	const getDataProcessListData = async (newObjectType, newObjectServer) => {
		const res: any = await getDataProcessList({
			businessCode: newObjectType,
			url: newObjectServer,
		});
		citeState.value.citeList = res.map((item) => ({
			value: objectValue.value ? item[objectValue.value] : '',
			label: objectLabel.value ? item[objectLabel.value] : '',
		}));
	};

	watch(
		[() => objectValue.value, () => objectLabel.value],
		([new1, new2]) => {
			if (new1 && new2) {
				getDataProcessListData(objectType.value, objectServer.value);
			}
		},
		{
			immediate: true,
		},
	);

	onMounted(async () => {
		if (paramsType.value === paramsTypeEnum.引用) {
			getCiteTypeList();
			if (citeType.value !== '') {
				getCiteList(citeType.value);
			}
		}
		if (paramsType.value === paramsTypeEnum.业务对象) {
			getObjectParams1();
			if (objectType.value !== '') {
				await getObjectParams2(objectType.value);
			}
			if (objectServer.value !== '') {
				getObjectParams3(objectServer.value);
			}
		}
	});
</script>

<style scoped lang="scss">
	.params-drag {
		padding: 0 10px;

		.params-drag-icon {
			padding: 2px 0px 0px 10px;
			cursor: move;
		}

		.form-item-content-icon {
			cursor: pointer;
		}

		.params-drag-ghost {
			outline: 1px solid #333;
		}
	}

	.params-checkbox {
		:deep(.el-checkbox__input) {
			margin-bottom: 14px;
		}
	}

	.select {
		width: 100%;
	}
</style>
